import { render, staticRenderFns } from "./inAppText.vue?vue&type=template&id=0733594e"
import script from "./inAppText.vue?vue&type=script&lang=js"
export * from "./inAppText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports